import React from 'react';
const horseContext = React.createContext([]);

export default horseContext;